function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Button/Close");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Button/Close",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6689969,14.0000306 L6.27566227,7.60670348 C5.90810627,7.23914529 5.90811512,6.64321311 6.27567357,6.27566057 C6.64322637,5.90811424 7.23914932,5.90811142 7.60669647,6.27566245 L14,12.668998 L20.3932753,6.27566245 C20.7608036,5.90811142 21.3567548,5.90811424 21.7242832,6.27566057 C22.0919056,6.64321311 22.0919056,7.23914529 21.7242832,7.60670348 L15.3309843,14.0000306 L21.7242832,20.3933388 C22.0918115,20.7608688 22.0918115,21.3568226 21.7242832,21.7243525 C21.3567548,22.0918825 20.7608036,22.0918825 20.3932753,21.7243525 L14,15.3310631 L7.60670588,21.7243525 C7.23914932,22.0918825 6.64323484,22.0918825 6.27568862,21.7243525 C5.90814712,21.3568226 5.9081506,20.7608688 6.27569615,20.3933388 L12.6689969,14.0000306 Z",
  id: "Path",
  fill: "#BCCCDC",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
})));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.bbd900fd.svg";
export { ForwardRef as ReactComponent };